export default __webpack_public_path__ + "media/carousel/wetransfer-2ff8a3f6.png";